<template>
    <span class="kioskMyPlace kioskPrintTable">
        <div id="printView">
			<div style="width: 302px;margin:0px">
				<img v-bind:src="$store.state.printAssets.logo" width="300" height="77"/>
				<br/>

				<span class="title">{{ $store.state.kioskEvent.name }}</span>
				<br/>

				<img v-bind:src="$store.state.printAssets.divider"/>
				<br/>
				{{ $t('table') }} {{ table.tableNum }}
				<br/>

                <ul>
                    <li style="border-bottom: 1px solid #a8a8a8;">
                        <span>{{ $t('name') }}</span>
                        <span style="float: left;">{{ $t('quantity') }}</span>
                    </li>
                    <li v-for="guest of guests" :key="guest.id">
                        <span>{{ guest.fullName }}</span>
                        <span style="float: left;">{{ guest.status.coming }}</span>
                    </li>
                </ul>

                <br/>
				<div class="footer">
					{{ $store.state.app.domain === 'app.seatup.co.il' || $store.state.app.domain === 'dev' ? '052-644-3837' : contactPhone }}<br/>
                    {{ $store.state.app.domain === "app.seatup.co.il" ? "www.seatup.co.il" : $store.state.app.domain }}
				</div>
			</div>
		</div>
        <div class="topFlo" v-if="!$store.state.kioskEvent.isConference"></div>
        <button @click="this.$parent.goBack" class="backBtn">
			<span>{{ $t('back') }}</span>
			<svg class="i_longArr"><use xlink:href="#i_longArr"></use></svg>
		</button>
        <h1>
			<span>{{ $t('tableNumber') }}</span>
			<span>{{ table.tableNum }}</span>
		</h1>
		<div class="mainImgWrap">
			<div class="listWrap scrollerWrap">
				<ul>

					<router-link @click.native="handleClick('/guests/myPlace/'+guest.id)" event="" v-bind:to="'/guests/myPlace/'+guest.id" tag="li" v-for="guest of guests" :key="guest.id">
						<span>{{ guest.fullName }}</span>
						<span class="peopleAmount">
							<svg class="i_user"><use xlink:href="#i_user"></use></svg>
							<span>{{ guest.status.coming }}x</span>
						</span>
					</router-link>

                    <li v-if="guests.length ===0" style="text-align: center">{{ $t('noGuestFound') }}</li>
				</ul>
			</div>
            <div class="listSum">
				<ul>
					<li>
						<div class="topLabel">{{ tableData.totalPlaces }}</div>
						<div class="bottomLabel">{{ $t('totalPlaces') }}</div>
					</li>
					<li>
						<div class="topLabel">{{ tableData.seated }}</div>
						<div class="bottomLabel">{{ $t('seated') }}</div>
					</li>
					<li>
						<div class="topLabel">{{ tableData.arrived }}</div>
						<div class="bottomLabel">{{ $t('arrived') }}</div>
					</li>
				</ul>
			</div>
			<button class="printBtn" @click="sendToPrinter()">
				<svg class="i_printer"><use xlink:href="#i_printer"></use></svg>
				<span>{{ $t('print') }}</span>
			</button>
		</div>
		<KioskFooter active="myPlace" :hideTables="true"></KioskFooter>
        <div class="bottomMenuWrap">
            <KioskLanguageSelector></KioskLanguageSelector>
            <AdminMenu v-on:openMenu="adminMenuOpened = true"></AdminMenu>
            <button class="adminEnt" @click.prevent="showArrivalStatus()">
                <Clock  />
            </button>
            <KioskArrivalStatus v-if="arrivalStatusOpened" v-on:close="arrivalStatusOpened = false"></KioskArrivalStatus>
        </div>
        <EventSelectModal @setEvent="setEvent" v-if="!$store.state.kioskEvent.id"></EventSelectModal>
        <AdminMenu :modal="true" v-if="adminMenuOpened" v-on:closeMenu="closeMenu"></AdminMenu>
        <Keyboard></Keyboard>
    </span>
</template>

<script>
    import KioskFooter from '../Kiosk/KioskFooter'
    import KioskLanguageSelector from '../Kiosk/KioskLanguageSelector'
    import EventSelectModal from '../Modals/EventSelectModal'
    import AdminMenu from '../Modals/AdminMenu'
    import Clock from 'vue-digital-clock'
    import Keyboard from './Keyboard'
    import KioskArrivalStatus from './KioskArrivalStatus'
    export default {
        name: "KioskTablePrint",
        components:{
            KioskLanguageSelector,
            EventSelectModal,
            AdminMenu,
            Clock,
            KioskArrivalStatus,
            KioskFooter,
            Keyboard
        },
        data(){
            return {
                adminMenuOpened:false,
                arrivalStatusOpened:false,
                guests:[],
                search:'',
                lastScroll:250,
                tableID:'',
                tableData:{
                    totalPlaces:0,
                    seated:0,
                    arrived:0,
                },
                table:{}
            }
        },
        destroyed(){
            try{
                $(".scrollerWrap").getNiceScroll().remove();
                $(".scrollerWrap").unbind("scroll");
            }
            catch(e){
                console.warn('failed to destroy nicescroll')
            }
        },
        mounted(){
            let _this = this;
            if(!this.$store.state.kioskEvent.id) {
                this.$router.push('/')
            }else{
                this.processKiosk();
            }

            $("#searchInput").off('change').on('change',function(){
                setTimeout(function(){
                    _this.search = $("#searchInput").val()
                },50);
            });
            $(".scrollerWrap").bind("scroll",function(){
                _this.lastScroll = Date.now();
            });
        },
        beforeMount(){
            if(typeof this.$router.currentRoute.params.id !=='undefined' && this.$router.currentRoute.params.id != ''){
                this.tableID = this.$router.currentRoute.params.id;
                this.processKiosk();
            }else{
                this.$router.push('/');
            }
        },
        methods:{
            handleClick(link) {
                const lastScroll = this.lastScroll !== "" ? Date.now()-this.lastScroll : 250;
                if(lastScroll >= 250) this.$router.push(link);
            },
            closeMenu(){
                this.adminMenuOpened = false;
                this.clicksCounter = 0;
            },
            setEvent(eventID){
                this.$store.state.kioskEvent = this.$store.state.closestEvents.filter(event => {
                    if(event.id == eventID) return true;
                    return false;
                }).pop();
                if(this.$store.state.kioskEvent.id){
                    this.processKiosk();
                }else{
                    this.$store.dispatch('logoff')
                }
            },
            processKiosk(){

                this.guests = this.$store.state.kioskEvent.guests.filter(guest=>{
                    return (guest.tableID == this.tableID);
                });

                this.tableData = {
                    totalPlaces:0,
                    seated:0,
                    arrived:0,
                };
                for(let guest of this.guests){
                    this.tableData.seated += guest.status.coming
                    if(guest.arrived) this.tableData.arrived += parseInt(guest.quantity) > 0 ? parseInt(guest.quantity) : 1;
                }

                for(let table of this.$store.state.kioskEvent.presetData){
                    if(table.dbID == this.tableID){
                        this.table = table;
                    }
                }

                this.tableData.totalPlaces = this.table.tableCapcity

                if(typeof $(".scrollerWrap").niceScroll !=='function') {
                    $.getScript("/static/js/niceScroll.min.js", function () {
                        $(".scrollerWrap").niceScroll({smoothscroll:true,hwacceleration:true,emulatetouch:true,grabcursorenabled:true,  cursordragontouch: true,cursordragontouch:true})
                    });
                }
                else{
                    $(".scrollerWrap").niceScroll({smoothscroll:true,hwacceleration:true,emulatetouch:true,grabcursorenabled:true,  cursordragontouch: true,cursordragontouch:true})
                }
            },
            showArrivalStatus(){
                this.arrivalStatusOpened = !this.arrivalStatusOpened;
                const _this = this;
                setTimeout(function(){ _this.arrivalStatusOpened = false },5000);
            },
            sendToPrinter(){
                $("#printView").show().css({display:'inline'});
                printJS({honorMarginPadding :false,printable: 'printView',type:'html',header:null,targetStyles:['*']})
                $("#printView").hide();
            }
        }
    }
</script>
<style>
    @page {
        margin: 0;
    }
    #printView{
        font-family: Arial;
        font-size:25px;
        width:100%;
        text-align: center;
        display: none;
    }
    #printView .title{
        font-weight: bold;
    }
    #printView .footer{
        font-size: 17px;
        margin-top: 10px;
        border-top: 1px solid #a8a8a8;
    }
    .kioskPrintTable #printView ul{
        list-style: none;
        width:100%;
        text-align: right;
    }
</style>
